"use client";
import { Dialog as Dialog$1, DialogContent as DialogContent$1, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXl, SpaceLg, SpaceSm, ModalShadow, SpaceMd, FontSize500, FontLineHeightMd, FontSize400 } from "@nxt-costco-com/forge-design-tokens";
import { Text } from "../../DataDisplay/Text/index.js";
const Dialog = styled(Dialog$1, {
  shouldForwardProp: (prop) => prop !== "sx"
})(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  zIndex: 200,
  "& .MuiPaper-root": {
    "&.MuiDialog-paper": {
      borderRadius: "6px",
      boxShadow: ModalShadow,
      margin: SpaceSm,
      maxWidth: "100%",
      verticalAlign: "top",
      width: `calc(100% - ${SpaceLg});`,
      "@media (min-width: 768px)": {
        margin: SpaceXl,
        width: "600px"
      }
    }
  }
}));
const dialogHeadingWrapperStyles = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  columnGap: "10px",
  padding: SpaceMd
};
const DialogContent = styled(DialogContent$1)(() => ({
  display: "flex",
  flexDirection: "column",
  rowGap: SpaceLg,
  padding: `0 ${SpaceMd} ${SpaceMd} ${SpaceMd}`
}));
const StyledButtonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isOneBtn"
})(({ isOneBtn, theme }) => ({
  width: "100%",
  display: "flex",
  rowGap: SpaceSm,
  columnGap: SpaceXl,
  flexDirection: "column",
  justifyContent: isOneBtn ? "flex-end" : "space-between",
  "> *": {
    width: "100%"
  },
  [`@media (min-width: ${theme.breakpoints.values.md}px)`]: {
    flexDirection: "row",
    "> *": {
      width: isOneBtn ? "247px" : "100%"
    }
  }
}));
const StyledText = styled(Text, {
  shouldForwardProp: () => true
})(() => ({
  fontSize: FontSize400,
  lineHeight: FontLineHeightMd,
  width: "100%",
  "@media (min-width: 768px)": {
    fontSize: FontSize500,
    lineHeight: 1
  }
}));
export {
  Dialog,
  DialogContent,
  StyledButtonContainer,
  StyledText,
  dialogHeadingWrapperStyles
};
